<template>
  <UiComponentWrapper class="page">
    <!-- Sticky > Navigation -->
    <UiComponentWrapper
      class="sticky-navigation"
      :class="{ active: !heroIsVisible }"
    >
      <UiComponentContainer>
        <NuxtLink
          class="back"
          :to="localePath('integrations')"
        >
          <UiComponentIcon type="chevron-left" />
          {{ data.hub.backCtaWording }}
        </NuxtLink>
        <UiComponentWrapper class="integration">
          <UiComponentImage
            v-if="data.page.icon"
            :alt="data.page.icon.alt"
            class="logo"
            :expected-size="48"
            :height="data.page.icon.height"
            :source="data.page.icon.url"
            :width="data.page.icon.width"
          />
          <UiComponentHeading :level="4">
            {{ data.page.title }}
          </UiComponentHeading>
        </UiComponentWrapper>
        <AtomButton
          :action="heroCallToAction.action"
          :attributes="heroCallToAction.attributes"
          size="l"
          :to="heroCallToAction.to"
        >
          <UiComponentIcon
            v-if="!!!data.page.contactUsLink && isLogged"
            type="plus"
          />
          {{ heroCallToAction.slot }}
        </AtomButton>
      </UiComponentContainer>
    </UiComponentWrapper>

    <!-- Section > Back -->
    <UiComponentContainer>
      <NuxtLink
        class="see-all-integrations"
        :to="localePath('integrations')"
      >
        <UiComponentIcon type="chevron-left" />
        {{ data.hub.backCtaWording }}
      </NuxtLink>
    </UiComponentContainer>

    <!-- Section > Hero -->
    <UiComponentContainer
      v-observe-visibility="onVisibilityChange"
      class="jumbotron"
    >
      <UiComponentWrapper
        class="gradient one"
        :style="{
          background: `radial-gradient(50% 50% at 50% 50%, rgba(${data.page.backgroundColor.red}, ${data.page.backgroundColor.green}, ${data.page.backgroundColor.blue}, 0.20) 0%, rgba(${data.page.backgroundColor.red}, ${data.page.backgroundColor.green}, ${data.page.backgroundColor.blue}, 0.00) 100%)`,
        }"
      />

      <UiComponentWrapper
        class="gradient two"
        :style="{
          background: `radial-gradient(50% 50% at 50% 50%, rgba(${data.page.backgroundColor.red}, ${data.page.backgroundColor.green}, ${data.page.backgroundColor.blue}, 0.10) 0%, rgba(${data.page.backgroundColor.red}, ${data.page.backgroundColor.green}, ${data.page.backgroundColor.blue}, 0.00) 100%)`,
        }"
      />

      <UiComponentWrapper class="informations">
        <UiComponentImage
          v-if="data.page.icon && !data.page.isPremium"
          :alt="data.page.icon.alt"
          class="logo"
          :expected-size="48"
          :height="data.page.icon.height"
          :source="data.page.icon.url"
          :width="data.page.icon.width"
        />
        <UiComponentWrapper
          v-else-if="data.page.icon && data.page.isPremium"
          class="logos"
        >
          <UiComponentWrapper
            class="logo"
            :style="{ '--background-color': data.page.backgroundColor.hex }"
          >
            <UiComponentImage
              :alt="data.page.icon.alt"
              :class="getClassBasedOnHexColor(data.page.backgroundColor.hex)"
              :expected-size="32"
              :height="data.page.icon.height"
              :source="data.page.icon.url"
              :width="data.page.icon.width"
            />
          </UiComponentWrapper>
          <UiComponentParagraph class="plus">
            +
          </UiComponentParagraph>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="storm"
              clip-path="url(#clip0_2854_1017)"
            >
              <path
                id="Subtract"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M47.996 23.998C47.996 24.2705 47.9964 24.5448 47.9967 24.8207C48.0056 31.2567 48.0155 38.5499 43.2845 43.297C38.577 48.0206 31.3295 48.0081 24.9167 47.997C24.6084 47.9964 24.3021 47.9959 23.9981 47.9959C23.7256 47.9959 23.4513 47.9963 23.1754 47.9967C16.7394 48.0055 9.44619 48.0155 4.69907 43.2844C-0.0244983 38.5769 -0.0119707 31.3294 -0.000885815 24.9166C-0.000352991 24.6083 0.0001765 24.302 0.0001765 23.998C0.0001765 23.7302 -0.00017949 23.4607 -0.000537495 23.1896C-0.00904208 16.7501 -0.0186836 9.44963 4.71585 4.69899C9.42341 -0.0245814 16.6709 -0.0120469 23.0801 -0.000962058C23.3881 -0.000429251 23.6943 0.000100208 23.9981 0.000100208C24.2657 0.000100208 24.535 -0.000255746 24.806 -0.000613732C31.2421 -0.00911833 38.5464 -0.0187701 43.2971 4.71577C48.0207 9.42333 48.0081 16.6708 47.997 23.08C47.9965 23.3881 47.996 23.6942 47.996 23.998ZM26.7039 11.4534H11.3527C9.99494 11.4534 8.89422 12.5542 8.89422 13.912C8.89422 15.2698 9.99494 16.3705 11.3527 16.3705H26.7039C28.0617 16.3705 29.1624 15.2698 29.1624 13.912C29.1624 12.5542 28.0617 11.4534 26.7039 11.4534ZM16.379 21.5392H31.7301C33.0879 21.5392 34.1887 22.6399 34.1887 23.9977C34.1887 25.3555 33.0879 26.4563 31.7301 26.4563H16.379C15.0212 26.4563 13.9205 25.3555 13.9205 23.9977C13.9205 22.6399 15.0212 21.5392 16.379 21.5392ZM26.7039 31.6292H21.405C20.0472 31.6292 18.9465 32.7299 18.9465 34.0877C18.9465 35.4455 20.0472 36.5463 21.405 36.5463H26.7039C28.0617 36.5463 29.1624 35.4455 29.1624 34.0877C29.1624 32.7299 28.0617 31.6292 26.7039 31.6292ZM36.647 11.4534C38.0048 11.4534 39.1055 12.5542 39.1055 13.912C39.1055 15.2698 38.0048 16.3705 36.647 16.3705C35.2892 16.3705 34.1885 15.2698 34.1885 13.912C34.1885 12.5542 35.2892 11.4534 36.647 11.4534Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_2854_1017">
                <rect
                  width="48"
                  height="48"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </UiComponentWrapper>
        <UiComponentHeading>{{ data.page.title }}</UiComponentHeading>
        <UiComponentParagraph>{{ data.page.text }}</UiComponentParagraph>
        <AtomButton
          :action="heroCallToAction.action"
          :attributes="heroCallToAction.attributes"
          :label="heroCallToAction.label"
          size="l"
          :to="heroCallToAction.to"
        >
          <UiComponentIcon
            v-if="!!!data.page.contactUsLink && isLogged"
            type="plus"
          />
          {{ heroCallToAction.slot }}
        </AtomButton>
      </UiComponentWrapper>
      <UiComponentWrapper
        v-if="hasSlider"
        class="images"
      >
        <UiComponentWrapper class="slider glide">
          <div
            class="glide__track w-full"
            data-glide-el="track"
          >
            <div class="flex glide__slides">
              <UiComponentImage
                v-for="image in data.page.images"
                :key="`${image.id}x${heroImageWidth}`"
                :alt="image.alt"
                :expected-size="heroImageWidth"
                :height="image.height"
                :lazyload="false"
                :source="image.url"
                :width="image.width"
              />
            </div>
          </div>
        </UiComponentWrapper>
        <UiComponentWrapper
          v-if="hasNavigation"
          class="navigation"
        >
          <UiComponentIcon
            class="prev"
            :class="{ disable: glideIndex === 0 }"
            type="chevron-left"
            @click="glide.go('<')"
          />
          <UiComponentWrapper
            v-for="n in data.page.images.length"
            :key="`bullet-${n}`"
            class="bullet"
            :class="{ active: glideIndex === n - 1 }"
            @click="glide.go(`=${n - 1}`)"
          />
          <UiComponentIcon
            class="next"
            :class="{
              disable: glideIndex === data.page.images.length - 1,
            }"
            type="chevron-right"
            @click="glide.go('>')"
          />
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper
        v-else
        class="no-images"
      >
        <UiComponentImage
          v-if="data.hub.sliderPlaceholderImage"
          :key="`no-slider-background-${heroImageWidth}`"
          :alt="data.hub.sliderPlaceholderImage.alt"
          :expected-size="heroImageWidth"
          :height="data.hub.sliderPlaceholderImage.height"
          :lazyload="false"
          :source="data.hub.sliderPlaceholderImage.url"
          :width="data.hub.sliderPlaceholderImage.width"
        />
        <UiComponentWrapper class="logo">
          <UiComponentImage
            v-if="data.page.logo"
            :alt="data.page.logo.alt"
            :expected-size="40"
            :height="data.page.logo.height"
            :lazyload="false"
            :orientation="data.page.logo.width >= data.page.logo.height ? 'portrait' : 'landscape'"
            :source="data.page.logo.url"
            :width="data.page.logo.width"
          />
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Main content -->
    <UiComponentContainer class="main">
      <UiComponentWrapper class="content">
        <UiComponentWrapper
          v-for="{
            id,
            __typename: typeOfContent,
            ...props
          } in content"
          :key="`section-${id}`"
          class="section"
          :class="{
            'faq': typeOfContent === 'ContentFaqRecord',
            'key-features': typeOfContent === 'ContentKeyFeatureRecord',
            'overview': typeOfContent === 'ContentOverviewRecord',
            'use-cases': typeOfContent === 'ContentUseCaseRecord',
            'definition': typeOfContent === 'DefinitionRecord',
            'image': typeOfContent === 'ImageRecord',
            'text': typeOfContent === 'TextRecord',
          }"
        >
          <!-- Content > FAQ -->
          <UiComponentWrapper
            v-if="typeOfContent === 'ContentFaqRecord'"
            class="inner"
          >
            <UiComponentWrapper class="head">
              <UiComponentTag type="secondary">
                {{ props.tag || data.hub.contentFaqWording }}
              </UiComponentTag>
              <UiComponentHeading :level="2">
                {{ props.title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ props.text }}</UiComponentParagraph>
            </UiComponentWrapper>
            <UiComponentWrapper class="body">
              <OrganismAccordion
                :items="props.items.map(({ title, text: content }) => ({ content, title }))"
              />
            </UiComponentWrapper>
          </UiComponentWrapper>

          <!-- Content > Key Features -->
          <UiComponentWrapper
            v-if="typeOfContent === 'ContentKeyFeatureRecord'"
            class="inner"
          >
            <UiComponentWrapper class="head">
              <UiComponentTag type="secondary">
                {{ props.tag || data.hub.contentKeyFeaturesWording }}
              </UiComponentTag>
              <UiComponentHeading :level="2">
                {{ props.title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ props.text }}</UiComponentParagraph>
            </UiComponentWrapper>
            <UiComponentWrapper class="body">
              <UiComponentWrapper
                v-for="feature in props.features"
                :key="`feature-${feature.id}`"
                class="feature"
              >
                <UiComponentHeading :level="3">
                  {{ feature.title }}
                </UiComponentHeading>
                <UiComponentParagraph>{{ feature.text }}</UiComponentParagraph>
                <UiComponentImage
                  v-if="feature.image"
                  :key="`feature-${feature.id}-${featureImageSize}`"
                  :alt="feature.image.alt"
                  :expected-size="featureImageSize"
                  :height="feature.image.height"
                  :source="feature.image.url"
                  :width="feature.image.width"
                />
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>

          <!-- Content > Overview -->
          <UiComponentWrapper
            v-if="typeOfContent === 'ContentOverviewRecord'"
            class="inner"
          >
            <UiComponentWrapper class="head">
              <UiComponentTag type="secondary">
                {{ props.tag || data.hub.contentOverviewWording }}
              </UiComponentTag>
              <UiComponentHeading :level="2">
                {{ props.title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ props.text }}</UiComponentParagraph>
            </UiComponentWrapper>
            <UiComponentWrapper
              v-if="props.keyNumbers.length > 0"
              class="body"
            >
              <UiComponentWrapper
                v-for="keyNumber in props.keyNumbers"
                :key="`key-number-${keyNumber.id}`"
                class="card"
              >
                <UiComponentParagraph class="value">
                  {{ keyNumber.value }}
                </UiComponentParagraph>
                <UiComponentParagraph class="caption">
                  {{ keyNumber.caption }}
                </UiComponentParagraph>
              </UiComponentWrapper>
            </UiComponentWrapper>
            <UiComponentWrapper class="footer">
              <UiComponentWrapper class="quote">
                <UiComponentImage
                  v-if="props.quote.customer && props.quote.customer.logo"
                  :alt="props.quote.customer.logo.alt"
                  class="customer"
                  :expected-size="32"
                  :extra-params="{
                    trim: 'color',
                  }"
                  :height="props.quote.customer.logo.height"
                  orientation="portrait"
                  :source="props.quote.customer.logo.url"
                  :width="props.quote.customer.logo.width"
                  use-natural-height
                  use-natural-width
                />
                <UiComponentWrapper class="rating">
                  <UiComponentWrapper
                    v-for="n in 5"
                    :key="`star-${n}`"
                    class="star"
                    :style="{
                      '--rating': props.quote.rating - n < 0 ? 1 - Math.abs(props.quote.rating - n) : 1,
                    }"
                  />
                </UiComponentWrapper>
                <UiComponentParagraph class="baseline">
                  {{ props.quote.baseline }}
                </UiComponentParagraph>
                <UiComponentParagraph class="citation">
                  {{ props.quote.citation }}
                </UiComponentParagraph>
                <UiComponentParagraph class="author">
                  {{ props.quote.author.name }}
                </UiComponentParagraph>
                <UiComponentParagraph class="job">
                  {{ props.quote.author.job }}
                </UiComponentParagraph>
                <UiComponentImage
                  :alt="props.quote.citation"
                  class="illustration"
                  :expected-size="124"
                  :height="504"
                  source="https://livestorm.imgix.net/1127/1704454059-quote.png"
                  :width="504"
                />
              </UiComponentWrapper>
              <UiComponentWrapper
                v-if="props.certification"
                class="certification"
                :style="data.page.secondaryColor
                  ? {
                    '--background-color': data.page.secondaryColor.hex,
                    '--border-color': `rgba(${data.page.secondaryColor.red},${data.page.secondaryColor.green},${data.page.secondaryColor.blue}, 0.2)`,
                  }
                  : undefined
                "
              >
                <UiComponentHeading
                  as="paragraph"
                  :level="3"
                >
                  {{ data.hub.contentOfficiallyCertifiedWording }}
                </UiComponentHeading>
                <AtomButton
                  type="text"
                  :to="props.certification.marketplaceUrl"
                >
                  {{ data.hub.contentSeeOnAppMarketplaceWording }}
                  <UiComponentIcon type="arrow-right" />
                </AtomButton>
                <UiComponentWrapper
                  class="badge"
                  :style="{
                    '--background-color': `rgba(255,255,255,0.8)`,
                    '--border-color': data.page.backgroundColor.hex,
                  }"
                >
                  <UiComponentWrapper class="inner">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="102"
                      height="102"
                      viewBox="0 0 102 102"
                      fill="none"
                    >
                      <path
                        d="M56.717 2.76415C61.0675 -1.70584 68.6343 0.321678 70.167 6.36807C71.2704 10.721 75.7476 13.3059 80.069 12.085C86.0717 10.3892 91.611 15.9285 89.9152 21.9311C88.6943 26.2525 91.2792 30.7298 95.6321 31.8332C101.678 33.3658 103.706 40.9327 99.236 45.2832C96.018 48.4152 96.018 53.5851 99.236 56.7171C103.706 61.0676 101.678 68.6344 95.6321 70.1671C91.2792 71.2705 88.6943 75.7477 89.9151 80.0691C91.611 86.0718 86.0717 91.6111 80.069 89.9152C75.7476 88.6944 71.2704 91.2793 70.167 95.6322C68.6343 101.679 61.0675 103.706 56.717 99.2361C53.585 96.0181 48.4151 96.0181 45.2831 99.2361C40.9326 103.706 33.3657 101.679 31.8331 95.6322C30.7297 91.2793 26.2524 88.6944 21.931 89.9153C15.9284 91.6111 10.3891 86.0718 12.0849 80.0691C13.3058 75.7477 10.7209 71.2705 6.36798 70.1671C0.321579 68.6344 -1.70594 61.0676 2.76405 56.7171C5.98207 53.5851 5.98207 48.4152 2.76405 45.2832C-1.70594 40.9327 0.321578 33.3658 6.36797 31.8332C10.7209 30.7298 13.3058 26.2525 12.0849 21.9311C10.3891 15.9285 15.9284 10.3892 21.931 12.085C26.2524 13.3059 30.7297 10.721 31.8331 6.36808C33.3657 0.321677 40.9326 -1.70585 45.2831 2.76415C48.4151 5.98217 53.585 5.98217 56.717 2.76415Z"
                        :fill="`rgba(${data.page.backgroundColor.red},${data.page.backgroundColor.green},${data.page.backgroundColor.blue},0.8)`"
                      />
                    </svg>
                    <UiComponentWrapper class="circle">
                      <UiComponentIcon
                        :style="{ color: `rgba(${data.page.backgroundColor.red},${data.page.backgroundColor.green},${data.page.backgroundColor.blue},0.8)` }"
                        type="check"
                      />
                      <UiComponentImage
                        v-if="data.page.logo"
                        :alt="data.page.logo.alt"
                        class="logo"
                        :expected-size="12"
                        :extra-params="{
                          trim: 'color',
                        }"
                        :height="data.page.logo.height"
                        :orientation="data.page.logo.width >= data.page.logo.height ? 'portrait' : 'landscape'"
                        :source="data.page.logo.url"
                        :width="data.page.logo.width"
                      />
                    </UiComponentWrapper>
                  </UiComponentWrapper>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>

          <!-- Content > Use Cases -->
          <UiComponentWrapper
            v-if="typeOfContent === 'ContentUseCaseRecord'"
            class="inner"
          >
            <UiComponentWrapper class="head">
              <UiComponentTag type="secondary">
                {{ props.tag || data.hub.contentUseCasesWording }}
              </UiComponentTag>
              <UiComponentHeading :level="2">
                {{ props.title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ props.text }}</UiComponentParagraph>
            </UiComponentWrapper>
            <UiComponentWrapper class="body">
              <UiComponentWrapper class="menu">
                <UiComponentWrapper
                  v-for="(useCase, index) in props.items"
                  :key="`menu-item-${useCase.id}`"
                  class="item"
                  :class="{ active: useCaseIndex === index }"
                  @click="useCaseIndex = index"
                >
                  {{ useCase.title }}
                </UiComponentWrapper>
              </UiComponentWrapper>
              <UiComponentWrapper class="items">
                <UiComponentWrapper
                  class="slider"
                  :style="{
                    transform: `translateX(-${(100*useCaseIndex)}%)`,
                  }"
                >
                  <UiComponentWrapper
                    v-for="(useCase, index) in props.items"
                    :key="`slide-${useCase.id}`"
                    class="slide"
                    :class="[
                      { active: useCaseIndex === index },
                      useCase.theme.color,
                    ]"
                  >
                    <UiComponentImage
                      :key="`slide-${useCase.id}-${useCaseImageSize}`"
                      :alt="useCase.image.alt"
                      class="illustration"
                      :expected-size="useCaseImageSize"
                      :height="useCase.image.height"
                      :source="useCase.image.url"
                      :width="useCase.image.width"
                    />
                    <UiComponentWrapper class="description">
                      <UiComponentWrapper class="type">
                        <UiComponentIcon :type="useCase.icon.type" />
                      </UiComponentWrapper>
                      <UiComponentHeading :level="3">
                        {{ useCase.title }}
                      </UiComponentHeading>
                      <UiComponentParagraph>{{ useCase.text }}</UiComponentParagraph>
                      <AtomButton
                        type="text"
                        :to="localePath({
                          name: 'use-cases-slug',
                          params: { slug: useCase.slug },
                        })"
                      >
                        {{ data.componentGlobal.learnMore }}
                        <UiComponentIcon type="arrow-right" />
                      </AtomButton>
                    </UiComponentWrapper>
                  </UiComponentWrapper>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>

          <!-- Content > Definition -->
          <UiComponentWrapper
            v-if="typeOfContent === 'DefinitionRecord' && props.title"
            class="inner"
          >
            <UiComponentWrapper class="head">
              <UiComponentIcon type="info" />
              <UiComponentHeading
                as="paragraph"
                :level="5"
              >
                {{ props.title }}
              </UiComponentHeading>
            </UiComponentWrapper>
            <UiComponentParagraph v-if="props.text">
              {{ props.text }}
            </UiComponentParagraph>
          </UiComponentWrapper>
          <!-- End -->

          <!-- Content > Image -->
          <UiComponentWrapper
            v-if="typeOfContent === 'ImageRecord' && props.image"
            class="inner"
          >
            <UiComponentImage
              :key="`content-image-${id}-${contentImagesWidth}`"
              :alt="props.image.alt"
              :expected-size="contentImagesWidth"
              :height="props.image.height"
              :source="props.image.url"
              :width="props.image.width"
            />
          </UiComponentWrapper>
          <!-- End -->

          <!-- Content > Text -->
          <div
            v-if="typeOfContent === 'TextRecord'"
            class="inner"
            v-html="$md.render(props.text)"
          />
          <!-- End -->
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper class="aside">
        <!-- Aside > Built By -->
        <UiComponentWrapper
          v-if="hasBuilder"
          class="built-by"
        >
          <UiComponentHeading
            as="paragraph"
            :level="5"
          >
            {{ data.hub.sidebarBuildByWording }}
          </UiComponentHeading>
          <UiComponentWrapper class="tags">
            <UiComponentWrapper
              class="tag"
            >
              {{ data.page.buildBy.name }}
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>

        <!-- Aside > Informations -->
        <UiComponentWrapper
          v-if="hasDocumentation || haveTags"
          class="informations"
        >
          <UiComponentHeading
            as="paragraph"
            :level="5"
          >
            {{ data.hub.sidebarInformationsWording }}
          </UiComponentHeading>
          <UiComponentWrapper
            v-if="haveTags"
            class="tags"
          >
            <UiComponentTag
              v-if="data.page.isEnterpriseOnly"
              class="is-enterprise-only"
              size="s"
            >
              <UiComponentImage
                alt="enterprise only plan"
                :expected-size="16"
                :height="16"
                source="https://livestorm.imgix.net/1127/1693920279-enterprise-plan-only.svg"
                :width="16"
              />
              <UiComponentParagraph>{{ data.hub.wordingForEnterprisePlanOnlyTag }}</UiComponentParagraph>
            </UiComponentTag>
            <UiComponentTag
              v-if="data.page.isFeatured"
              class="is-featured"
              size="s"
            >
              <UiComponentImage
                alt="featured"
                :expected-size="16"
                :height="16"
                source="https://livestorm.imgix.net/1127/1693920280-featured.svg"
                :width="16"
              />
              <UiComponentParagraph>{{ data.hub.wordingForFeaturedTag }}</UiComponentParagraph>
            </UiComponentTag>
            <UiComponentTag
              v-if="data.page.isNew"
              class="is-new"
              size="s"
            >
              <UiComponentImage
                alt="new"
                :expected-size="16"
                :height="16"
                source="https://livestorm.imgix.net/1127/1693920281-new.svg"
                :width="16"
              />
              <UiComponentParagraph>{{ data.hub.wordingForNewTag }}</UiComponentParagraph>
            </UiComponentTag>
          </UiComponentWrapper>
          <UiComponentWrapper
            v-if="hasDocumentation"
            class="links"
          >
            <AtomAnchor
              v-if="data.page.contactUsLink"
              :to="data.page.contactUsLink"
            >
              {{ data.componentGlobal.contactUs }}
              <UiComponentIcon type="external-link" />
            </AtomAnchor>
            <AtomAnchor
              v-if="data.page.internalDocumentation"
              :to="data.page.internalDocumentation"
            >
              {{ data.hub.sidebarSeeOurDocumentationWording }}
              <UiComponentIcon type="external-link" />
            </AtomAnchor>
            <AtomAnchor
              v-if="data.page.externalDocumentation"
              :to="data.page.externalDocumentation"
            >
              {{ data.hub.sidebarSeeZapierDocumentationWording }}
              <UiComponentIcon type="external-link" />
            </AtomAnchor>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <!-- End -->

        <!-- Aside > Integrated With -->
        <UiComponentWrapper
          v-if="haveIntegrationMethods"
          class="integrated-with"
        >
          <UiComponentHeading
            as="paragraph"
            :level="5"
          >
            {{ data.hub.sidebarIntegratedWithWording }}
          </UiComponentHeading>
          <UiComponentWrapper class="tags">
            <UiComponentWrapper
              v-for="{ id, name } in data.page.integratedWith"
              :key="`intergrated-with-${id}`"
              class="tag"
            >
              {{ name }}
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <!-- End -->

        <!-- Aside > Category -->
        <UiComponentWrapper
          v-if="haveCategories"
          class="category"
        >
          <UiComponentHeading
            as="paragraph"
            :level="5"
          >
            {{ data.hub.sidebarCategoryWording }}
          </UiComponentHeading>
          <UiComponentWrapper class="tags">
            <UiComponentWrapper
              v-for="{ id, name } in data.page.categories"
              :key="`category-${id}`"
              class="tag"
            >
              {{ name }}
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <!-- End -->

        <!-- Aside > Shared Data -->
        <UiComponentWrapper
          v-if="haveSharedData"
          class="shared-data"
        >
          <UiComponentHeading
            as="paragraph"
            :level="5"
          >
            {{ data.hub.sidebarSharedDataWording }}
          </UiComponentHeading>
          <UiComponentWrapper class="list">
            <UiComponentWrapper class="item">
              <UiComponentParagraph>{{ data.page.title }}</UiComponentParagraph>
              <UiComponentParagraph>Livestorm</UiComponentParagraph>
            </UiComponentWrapper>
            <UiComponentWrapper
              v-for="{ id, livestormSide, integrationSide } in data.page.sharedData"
              :key="`shared-data-${id}`"
              class="item"
            >
              <UiComponentParagraph>{{ integrationSide }}</UiComponentParagraph>
              <UiComponentParagraph>{{ livestormSide }}</UiComponentParagraph>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <!-- End -->

        <!-- Aside > Permissions -->
        <UiComponentWrapper
          v-if="havePermissions"
          class="permissions"
        >
          <UiComponentHeading
            as="paragraph"
            :level="5"
          >
            {{ data.hub.sidebarPermissionsWording }}
          </UiComponentHeading>
          <div
            class="content"
            v-html="$md.render(data.page.permissions)"
          />
        </UiComponentWrapper>
        <!-- End -->
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Need anything else -->
    <UiComponentContainer class="need-anything-else">
      <UiComponentWrapper class="inner">
        <UiComponentImage
          v-if="illustrationSize"
          :key="`illustration-mobile-${illustrationSize}`"
          :alt="data.componentNeedAnythingElse.mobileBackground.alt"
          class="background mobile"
          :expected-size="illustrationSize"
          :height="data.componentNeedAnythingElse.mobileBackground.height"
          :source="data.componentNeedAnythingElse.mobileBackground.url"
          :width="data.componentNeedAnythingElse.mobileBackground.width"
        />
        <UiComponentImage
          v-if="illustrationSize"
          :key="`illustration-desktop-${illustrationSize}`"
          :alt="data.componentNeedAnythingElse.desktopBackground.alt"
          class="background desktop"
          :expected-size="illustrationSize"
          :height="data.componentNeedAnythingElse.desktopBackground.height"
          orientation="portrait"
          :source="data.componentNeedAnythingElse.desktopBackground.url"
          :width="data.componentNeedAnythingElse.desktopBackground.width"
        />
        <UiComponentHeading
          as="paragraph"
          :level="4"
        >
          {{ data.componentNeedAnythingElse.title }}
        </UiComponentHeading>
        <UiComponentParagraph>{{ data.componentNeedAnythingElse.text }}</UiComponentParagraph>
        <AtomButton
          :to="localePath('integrations')"
          type="text"
        >
          {{ data.componentNeedAnythingElse.ctaWording }}
          <UiComponentIcon type="arrow-right" />
        </AtomButton>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > You may also like -->
    <UiComponentContainer
      v-if="data.relatedIntegrations.length > 0"
      class="you-may-like"
    >
      <UiComponentWrapper class="head">
        <div class="line" />
        <UiComponentParagraph size="s">
          {{ data.hub.youMayAlsoLikeTitle }}
        </UiComponentParagraph>
        <div class="line" />
      </UiComponentWrapper>
      <UiComponentWrapper class="body">
        <MoleculeIntegrationCard
          v-for="integration in data.relatedIntegrations"
          :key="integration.id"
          :integration="integration"
        >
          <template #enterprise>
            {{ data.hub.wordingForEnterprisePlanOnlyTag }}
          </template>
          <template #featured>
            {{ data.hub.wordingForFeaturedTag }}
          </template>
          <template #new>
            {{ data.hub.wordingForNewTag }}
          </template>
        </MoleculeIntegrationCard>
      </UiComponentWrapper>
    </UiComponentContainer>
  </UiComponentWrapper>
</template>

<script setup>
import Glide from '@glidejs/glide'

// Layout
definePageMeta({
  layout: 'default',
  middleware: [
    'check-if-the-integration-exists',
  ],
})

// i18n
defineI18nRoute({
  locales: ['en', 'es', 'fr'],
  paths: {
    en: '/integrations/[slug]',
    es: '/integraciones/[slug]',
    fr: '/integrations/[slug]',
  },
})

// Composables
const { page } = useAnalyticsJS()
const { setAvailableLanguages } = useAvailableLanguages()
const { updateListItems } = useBreadcrumb()
const { state } = useConditionalPreviewMode()
const { locale } = useI18n()
const { isLogged } = useIsLoggedIn()
const localePath = useLocalePath()
const { $md } = useMarkdown()
const { meta, params } = useRoute()
const getRouteBaseName = useRouteBaseName()
const { public: publicRuntimeConfig } = useRuntimeConfig()
const { width: screenWidth } = useScreenSize()

// Directives
const { vObserveVisibility } = useVObserveVisibility()

// Async Data
const { data } = await useFetch(`/api/content/pages/integrations/${locale.value}`, {
  key: `page-integrations-[slug]-${params.slug}-${locale.value}`,
  query: {
    preview: state.preview,
  },
  transform: (input) => {
    const { allIntegrations, ...props } = input
    const page = allIntegrations.find(({ slug }) => slug === params.slug)
    const relatedIntegrations = page.relatedIntegrations
      .map(({ id }) => allIntegrations.find(intergration => intergration.id === id))
      .map(mapIntegration)

    return {
      ...props,
      hub: props.page,
      page,
      relatedIntegrations,
    }
  },
})

if (!data.value?.page) {
  throw createError({ statusCode: 404, message: 'Page not found' })
}

// Meta
const alternativeVersions = data.value.page.alternativeContent
  .filter(({ value }) => value.length > 0)
  .map(({ locale }) => {
    return data.value.page.alternativeVersions
      .find(version => version.locale === locale)
  })
const locales = alternativeVersions.map(({ locale }) => locale)

meta.nuxtI18n = alternativeVersions.reduce(
  (accumator, { locale, value: slug }) => ({
    ...accumator,
    [locale]: { slug },
  }),
  {},
)

const head = useLocaleHead({
  identifierAttribute: 'id',
  addSeoAttributes: true,
})

useSeoMeta({
  title: data.value.page.titleSeo || data.value.page.titleSeoFallback,
  description: data.value.page.descriptionSeo,
  ogTitle: data.value.page.titleSeo || data.value.page.titleSeoFallback,
  ogDescription: data.value.page.descriptionSeo,
  twitterTitle: data.value.page.titleSeo || data.value.page.titleSeoFallback,
  twitterDescription: data.value.page.descriptionSeo,
})

useHead({
  link: head.value.link
    .filter((link) => {
      return link.rel === 'canonical'
        || (link.rel === 'alternate' && link.hreflang === 'x-default')
        || (link.rel === 'alternate' && locales.includes(link.hreflang))
    })
    .map((link) => {
      return {
        ...link,
        href: !locales.includes('en') && link.id === 'i18n-xd'
          ? `${publicRuntimeConfig.baseUrl}${localePath({ name: getRouteBaseName() })}`
          : link.href,
      }
    }),
  meta: head.value.meta.filter((meta) => {
    return meta.property === 'og:url'
      || meta.property === 'og:locale'
      || (meta.property === 'og:locale:alternate' && locales.includes(meta.content))
  }),
  script: [
    {
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': [
          {
            '@type': 'ListItem',
            'position': 1,
            'name': data.value.home.trackingBreadcrumbTitle,
            'item': `${publicRuntimeConfig.baseUrl}${localePath('index')}`,
          },
          {
            '@type': 'ListItem',
            'position': 2,
            'name': data.value.hub.trackingBreadcrumbTitle,
            'item': `${publicRuntimeConfig.baseUrl}${localePath('integrations')}`,
          },
          {
            '@type': 'ListItem',
            'position': 3,
            'name': data.value.page.trackingBreadcrumbTitle || data.value.page.title,
          },
        ],
      }),
      type: 'application/ld+json',
    },
  ],
})

// Refs
const glide = ref(null)
const glideIndex = ref(0)
const heroIsVisible = ref(true)
const illustrationSize = ref(null)
const resizeObserver = ref(null)
const useCaseIndex = ref(0)

// Computed Properties
const content = computed(() => {
  return data.value.page.content
})

const contentImagesWidth = computed(() => {
  switch (true) {
    case screenWidth.value < 768:
      return screenWidth.value - 32
    case screenWidth.value >= 768 && screenWidth.value < 1024:
      return screenWidth.value - 48
    case screenWidth.value >= 1024 && screenWidth.value < 1328:
      return Math.round(840 * (screenWidth.value / 1328))
    case screenWidth.value >= 1328:
      return 840
    default:
      return 840
  }
})

const featureImageSize = computed(() => {
  switch (true) {
    case screenWidth.value < 768:
      return screenWidth.value - 32
    default:
      return 630
  }
})

const hasBuilder = computed(() => {
  return data.value.page.buildBy
})

const hasDocumentation = computed(() => {
  return data.value.page.internalDocumentation || data.value.page.externalDocumentation || data.value.page.contactUsLink
})

const hasNavigation = computed(() => {
  return data.value.page.images.length > 1
})

const hasSlider = computed(() => {
  return data.value.page.images.length > 0
})

const haveCategories = computed(() => {
  return data.value.page.categories.length > 0
})

const haveIntegrationMethods = computed(() => {
  return data.value.page.integratedWith.length > 0
})

const havePermissions = computed(() => {
  return !!data.value.page.permissions
})

const haveSharedData = computed(() => {
  return data.value.page.sharedData.length > 0
})

const haveTags = computed(() => {
  return data.value.page.isEnterpriseOnly || data.value.page.isFeatured || data.value.page.isNew
})

const heroCallToAction = computed(() => {
  return {
    attributes: isLogged.value
      ? {
          action: data.value.page.contactUsLink || data.value.page.appLink || data.value.page.internalDocumentation || data.value.page.externalDocumentation,
        }
      : {
          action: data.value.page.contactUsLink || data.value.page.customLink || `https://${publicRuntimeConfig.appBaseUrl}/#/signup`,
        },
    action: isLogged.value
      ? 'Button clicked'
      : 'Signup clicked',
    label: 'Header section CTA',
    slot: data.value.page.contactUsLink
      ? data.value.componentGlobal.contactUs
      : isLogged.value
        ? data.value.hub.heroInstallCtaWording
        : data.value.hub.heroSignupCtaWording,
    to: isLogged.value
      ? data.value.page.contactUsLink || data.value.page.appLink || data.value.page.internalDocumentation || data.value.page.externalDocumentation
      : data.value.page.contactUsLink || data.value.page.customLink || `https://${publicRuntimeConfig.appBaseUrl}/#/signup`,
  }
})

const heroImageWidth = computed(() => {
  switch (true) {
    case screenWidth.value < 768:
      return screenWidth.value - 32
    case screenWidth.value >= 768 && screenWidth.value < 1328:
      return screenWidth.value - 48
    default:
      return 620
  }
})

const useCaseImageSize = computed(() => {
  switch (true) {
    case screenWidth.value < 768:
      return screenWidth.value - 32 - 48
    case screenWidth.value >= 768 && screenWidth.value < 1328:
      return screenWidth.value - 48 - 64
    default:
      return 368
  }
})

// Methods
function getClassBasedOnHexColor(color) {
  if (!/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color)) {
    throw new Error('Invalid color format. Use #RRGGBB or #RGB format.')
  }
  const hex = color.length === 4
    ? `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`
    : color
  const r = parseInt(hex.substr(1, 2), 16)
  const g = parseInt(hex.substr(3, 2), 16)
  const b = parseInt(hex.substr(5, 2), 16)
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b
  return luminance > 186 ? 'black' : 'white'
}

function mapIntegration({ id, categories, isEnterpriseOnly, isFeatured, isNew, icon: logo, title, text, shortText, slug }) {
  return {
    id,
    categories: categories.map(({ name }) => name),
    logo,
    tags: {
      isEnterpriseOnly,
      isFeatured,
      isNew,
    },
    title,
    text: shortText || text,
    slug,
  }
}

function onIndexChange() {
  glideIndex.value = glide.value.index
}

function onObserve() {
  const { clientWidth } = document.documentElement
  const { offsetHeight, offsetWidth } = document.querySelector('.page .need-anything-else')
  illustrationSize.value = clientWidth >= 768 ? offsetHeight : offsetWidth
}

function onVisibilityChange(isVisible) {
  heroIsVisible.value = isVisible
}

// Lifecycle Hooks
onBeforeUnmount(() => {
  glide.value?.destroy()

  resizeObserver.value.disconnect()
})

onMounted(() => {
  page(
    data.value.page.trackName
    || data.value.page.trackNameFallback,
  )
  setAvailableLanguages(
    data.value.page.alternativeContent
      .filter(({ value }) => value.length > 0).map(({ locale }) => locale),
  )
  updateListItems([
    {
      item: localePath('index'),
      name: data.value.home.trackingBreadcrumbTitle,
    },
    {
      item: localePath('integrations'),
      name: data.value.hub.trackingBreadcrumbTitle,
    },
    {
      item: localePath({ name: getRouteBaseName() }),
      name: data.value.page.trackingBreadcrumbTitle || data.value.page.title,
    },
  ])

  if (hasSlider.value) {
    glide.value = new Glide('.jumbotron .glide', {
      gap: 0,
      perView: 1,
      rewind: false,
      type: 'slider',
    })
    glide.value.on('run.after', onIndexChange)
    glide.value.mount()
  }

  resizeObserver.value = new ResizeObserver(onObserve)
  resizeObserver.value.observe(document.querySelector('.page .need-anything-else'))
})
</script>

<style lang="postcss" scoped>
@import "../../assets/css/glide.css";

.page {
  @apply relative flex-col items-center -mt-14 -mb-8 pt-14 overflow-hidden;

  @screen md {
    @apply -mt-18 pt-18;
  }

  .sticky-navigation {
    @apply fixed top-0 self-start justify-center py-8 bg-white border-b border-grey-blue-200 transform -translate-y-full z-50 transition-transform duration-600 ease-in-out;

    &.active {
      @apply translate-y-0;
    }

    .container {
      @apply flex-col;

      @screen md {
        @apply flex-row flex-wrap justify-between;
      }

      .back {
        @apply flex items-center w-full font-medium text-grey-blue-900 text-sm leading-6;

        i {
          @apply mr-2 text-grey-blue-900 text-base leading-none;
        }
      }

      .integration {
        @apply items-center w-full mt-4;

        @screen md {
          @apply self-start w-auto;
        }

        .logo {
          @apply flex-shrink-0 mr-2 rounded-none;
        }

        .h4 {
          @apply text-2xl leading-8 !important;
        }
      }

      .button {
        @apply mt-4;

        @screen md {
          @apply self-end w-auto;
        }

        i {
          @apply mr-2 text-white;
        }
      }
    }
  }

  .see-all-integrations {
    @apply flex items-center py-8 font-medium text-grey-blue-900 text-sm leading-6 z-10;

    i {
      @apply mr-2 text-grey-blue-900 text-base leading-none;
    }
  }

  .jumbotron {
    @apply relative flex-col;

    @screen xl {
      @apply flex-row flex-wrap justify-between;
    }

    .gradient {
      @apply absolute max-h-none max-w-none rounded-full z-0;

      &.one {
        @apply -left-[430px] -top-[632px] h-[1026px] w-[1026px];
      }

      &.two {
        @apply hidden;

        @screen xl {
          @apply -right-[212px] -top-[29px] flex h-[650px] w-[650px];
        }
      }
    }

    .informations {
      @apply flex-col z-10;

      @screen xl {
        @apply w-span6;
      }

      .logos {
        @apply items-center gap-2;

        .logo {
          @apply items-center justify-center bg-[var(--background-color)] h-12 w-12 rounded-xl;

          .black {
            filter: brightness(0) saturate(100%);
          }

          .white {
            filter: brightness(0) saturate(100%) invert(100%) sepia(5%) saturate(0%) hue-rotate(328deg) brightness(104%) contrast(100%);
          }
        }

        .plus {
          @apply m-0 text-base text-winter-green-900 leading-none;
        }

        & + .h1 {
          @apply mt-8;
        }
      }

      .logo {
        @apply rounded-none;
      }

      .h1 {
        @apply mt-4 text-3xl leading-10;

        @screen mdminus {
          @apply font-medium text-3xl leading-10;
        }

        @screen mdplus {
          @apply font-normal text-5xl leading-16;
        }

        :deep(b),
        :deep(strong) {
          @screen mdminus {
            @apply font-medium;
          }

          @screen mdplus {
            @apply font-normal;
          }
        }
      }

      p {
        @apply mt-4 text-grey-blue-600 leading-7;
      }

      .button {
        @apply mt-6;

        @screen md {
          @apply self-start;
        }

        i {
          @apply mr-2 text-white;
        }
      }
    }

    .no-images {
      @apply relative self-start w-auto mt-10 z-10;

      @screen xl {
        @apply w-span6 mt-0;
      }

      .logo {
        @apply absolute top-1/2 left-1/2 w-auto transform -translate-x-1/2 -translate-y-1/2;

        picture {
          @apply rounded-none;
        }
      }
    }

    .images {
      @apply flex-col mt-10 z-10;

      @screen xl {
        @apply w-span6 mt-0;
      }

      .navigation {
        @apply flex flex-row w-full justify-center items-center mt-6;

        .prev,
        .next {
          @apply font-semibold text-livestorm-blue-700 cursor-pointer transition duration-500 ease-out;

          &.disable {
            @apply text-livestorm-blue-200 cursor-default;
          }
        }

        .prev {
          @apply mr-6;
        }

        .bullet {
          @apply w-3 h-3 ml-2 mr-2 rounded-full bg-livestorm-blue-200 cursor-pointer transition duration-500 ease-out;

          &.active {
            @apply bg-livestorm-blue-700 cursor-default;
          }

          &:first-child {
            @apply ml-0;
          }

          &:last-child {
            @apply mr-0;
          }
        }

        .next {
          @apply ml-6;
        }
      }
    }
  }

  .main {
    @apply flex-col mt-14 z-10;

    @screen md {
      @apply mt-26;
    }

    @screen xl {
      @apply flex-row flex-wrap justify-between;
    }

    .content {
      @apply flex-col;

      @screen xl {
        @apply w-span8;
      }

      .section {
        @apply mt-14;

        @screen md {
          @apply mt-20;
        }

        &:first-child {
          @apply mt-0;
        }

        &.definition {
          @apply relative mt-4 p-6 bg-livestorm-blue-100 rounded-4xl;

          @screen md {
            @apply p-8;
          }

          .inner {
            @apply flex-col;

            .head {
              @apply items-center gap-3;

              i {
                @apply text-2xl text-livestorm-blue-700 leading-none;
              }

              .h5 {
                @apply m-0 p-0 text-livestorm-blue-700;
              }
            }

            p {
              @apply mt-1 pl-9 text-grey-blue-600 text-origin leading-7;
            }
          }
        }

        &.faq {
          .inner {
            @apply flex-col gap-12;

            .head {
              @apply flex-col gap-4;

              .tag {
                @apply self-start;
              }

              .h2 {
                @apply font-medium text-2xl leading-8;

                @screen mdminus {
                  @apply text-[28px] leading-[34px];
                }

                @screen mdplus {
                  @apply text-3xl leading-10;
                }

                :deep(b),
                :deep(strong) {
                  @apply font-medium;
                }
              }
            }

            .body {
              @apply flex-col;
            }
          }
        }

        &.image {
          @apply bg-grey-blue-100 rounded-4xl overflow-hidden;

          &:deep(picture) {
            @apply rounded-none;
          }
        }

        &.key-features {
          .inner {
            @apply flex-col gap-12;

            .head {
              @apply flex-col gap-4;

              .tag {
                @apply self-start;
              }

              .h2 {
                @apply font-medium text-2xl leading-8;

                @screen mdminus {
                  @apply text-[28px] leading-[34px];
                }

                @screen mdplus {
                  @apply text-3xl leading-10;
                }

                :deep(b),
                :deep(strong) {
                  @apply font-medium;
                }
              }
            }

            .body {
              @apply flex-col gap-10;

              .feature {
                @apply flex-col gap-4;

                .h3 {
                  @apply text-xl leading-7;

                  @screen mdminus {
                    @apply text-2xl leading-8;
                  }

                  @screen mdplus {
                    @apply text-2xl leading-8;
                  }
                }

                picture {
                  @apply mt-2;
                }
              }
            }
          }
        }

        &.overview {
          .inner {
            @apply flex-col gap-10;

            .head {
              @apply flex-col gap-4;

              .tag {
                @apply self-start;
              }

              .h2 {
                @apply font-medium text-2xl leading-8;

                @screen mdminus {
                  @apply text-[28px] leading-[34px];
                }

                @screen mdplus {
                  @apply text-3xl leading-10;
                }

                :deep(b),
                :deep(strong) {
                  @apply font-medium;
                }
              }
            }

            .body {
              @apply flex-col-reverse gap-6;

              @screen md {
                @apply flex-row flex-wrap gap-10;
              }

              .card {
                @apply flex-col gap-1 p-8 bg-white border-2 border-grey-blue-200 rounded-3xl;

                @screen md {
                  width: calc((100% - 80px) / 3);
                }

                .value {
                  @apply font-bold text-winter-green-900 text-5xl leading-[normal];
                }
              }
            }

            .footer {
              @apply flex-col gap-10;

              @screen lg {
                @apply flex-row;
              }

              .quote {
                @apply relative flex-col p-6 bg-grey-blue-100 border-2 border-grey-blue-200 rounded-3xl;

                @screen md {
                  @apply p-8;
                }

                .customer {
                  @apply rounded-none;
                }

                .rating {
                  @apply justify-between w-[91px] mt-2;

                  .star {
                    @apply relative w-4 h-4 bg-grey-blue-300;
                    mask-image: url(@/assets/svg/star-rounded.svg);
                    mask-repeat: no-repeat;
                    mask-size: 16px;

                    &::after {
                      @apply absolute h-4 bg-sandstorm-yellow-600 content-[''];
                      width: calc(var(--rating) * 100%);
                    }
                  }
                }

                .baseline {
                  @apply mt-6 font-medium text-winter-green-900 text-sm leading-[160%];
                }

                .citation {
                  @apply mt-1 text-grey-blue-600 text-sm leading-[160%];
                }

                .author {
                  @apply mt-6 font-medium text-winter-green-900 text-base leading-6;
                }

                .job {
                  @apply text-grey-blue-600 text-sm leading-5;
                }

                .illustration {
                  @apply absolute -right-10 -top-10 rounded-none;
                }
              }

              .certification {
                @apply relative flex-col h-[254px] bg-[var(--background-color)] border-2 border-[var(--background-color)] p-6 rounded-[32px];

                @screen md {
                  @apply p-8;
                }

                @screen lg {
                  @apply flex-shrink-0 h-auto;
                  width: calc((100% - 80px) / 3);
                }

                .h3 {
                  @apply self-center my-auto text-center;
                }

                .button {
                  @apply absolute bottom-6 self-center px-0 font-normal text-livestorm-blue-700 text-sm leading-none;

                  :deep(i) {
                    @apply ml-1 text-livestorm-blue-700;
                  }
                }

                .badge {
                  @apply absolute -right-6 -top-6 h-[102px] w-[102px];

                  .inner {
                    @apply relative items-center justify-center h-full w-full p-3;

                    > svg {
                      @apply absolute z-0;
                    }

                    .circle {
                      @apply flex-col items-center justify-center h-full w-full bg-[var(--background-color)] border-2 border-[var(--border-color)] rounded-full transform rotate-[15deg] z-10;

                      i {
                        @apply font-bold text-3xl leading-none;
                      }

                      .logo {
                        @apply -mt-1 rounded-none;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        &.text {
          .inner {
            @apply flex flex-col;

            :deep(a) {
              @apply font-normal text-livestorm-blue-700;
            }

            :deep(b),
            :deep(strong) {
              @apply font-medium;
            }

            :deep(blockquote) {
              @apply p-8 bg-livestorm-blue-100 rounded-4xl;

              @screen md {
                @apply p-10;
              }

              p {
                @apply inline text-center text-livestorm-blue-700 text-xl leading-[160%];

                &::before,
                &::after {
                  @apply inline;
                }

                &::before {
                  @apply content-['“'];
                }

                &::after {
                  @apply content-['”'];
                }
              }
            }

            :deep(h2),
            :deep(h3),
            :deep(h4),
            :deep(h5),
            :deep(h6) {
              @apply text-winter-green-900 whitespace-pre-line font-medium;

              b,
              strong {
                @apply font-medium text-livestorm-blue-700;
              }
            }

            :deep(h2) {
              @apply text-2xl leading-8;

              @screen mdminus {
                font-size: 28px;
                line-height: 34px;
              }

              @screen mdplus {
                @apply text-3xl leading-10;
              }
            }

            :deep(h3) {
              @apply text-xl leading-7;

              @screen mdminus {
                @apply text-2xl leading-8;
              }

              @screen mdplus {
                @apply text-2xl leading-8;
              }
            }

            :deep(h4) {
              @apply text-origin leading-7;

              @screen mdminus {
                @apply text-xl;
              }

              @screen mdplus {
                @apply text-xl;
              }
            }

            :deep(h5),
            :deep(h6) {
              @apply text-origin leading-7;
            }

            :deep(ol) {
              @apply ml-4;

              li {
                @apply font-normal mt-3 text-grey-blue-600 text-origin leading-7 list-decimal list-inside marker:text-livestorm-blue-700;

                &:first-child {
                  @apply mt-0;
                }
              }
            }

            :deep(ul) {
              @apply ml-4;

              li {
                @apply block mt-4 font-normal text-grey-blue-600 text-origin leading-7;

                &:first-child {
                  @apply mt-0;
                }

                &::before {
                  @apply inline-block w-3 h-3 bg-livestorm-blue-700 mr-4 rounded-[3px] content-[''];
                }
              }
            }

            :deep(p) {
              @apply text-grey-blue-600 text-origin leading-7 whitespace-pre-wrap;
            }

            :deep(blockquote + p),
            :deep(p + blockquote),
            :deep(p + p),
            :deep(p + ol),
            :deep(p + ul),
            :deep(ol + p),
            :deep(ul + p) {
              @apply mt-4;
            }

            :deep(h2 + blockquote),

            :deep(h2 + p),
            :deep(h3 + p),
            :deep(h4 + p),
            :deep(h5 + p),
            :deep(h6 + p),
            :deep(h2 + ol),
            :deep(h3 + ol),
            :deep(h4 + ol),
            :deep(h5 + ol),
            :deep(h6 + ol),
            :deep(h2 + ul),
            :deep(h3 + ul),
            :deep(h4 + ul),
            :deep(h5 + ul),
            :deep(h6 + ul) {
              @apply mt-6;
            }

            :deep(* + blockquote),
            :deep(* + h2) {
              @apply mt-14;

              @screen md {
                @apply mt-20;
              }
            }

            :deep(* + h3),
            :deep(* + h4),
            :deep(* + h5),
            :deep(* + h6) {
              @apply mt-8;

              @screen md {
                @apply mt-10;
              }
            }
          }
        }

        &.use-cases {
          .inner {
            @apply flex-col gap-10;

            .head {
              @apply flex-col gap-4;

              .tag {
                @apply self-start;
              }

              .h2 {
                @apply font-medium text-2xl leading-8;

                @screen mdminus {
                  @apply text-[28px] leading-[34px];
                }

                @screen mdplus {
                  @apply text-3xl leading-10;
                }

                :deep(b),
                :deep(strong) {
                  @apply font-medium;
                }
              }
            }

            .body {
              @apply flex-col gap-10;

              .menu {
                @apply self-center flex-nowrap w-auto overflow-scroll;

                .item {
                  @apply flex-shrink-0 w-auto px-3 py-2 bg-transparent font-medium text-grey-blue-600 cursor-pointer rounded-lg transition-colors duration-300 ease-in-out;

                  &.active {
                    @apply bg-grey-blue-100 text-winter-green-900;
                  }
                }
              }

              .items {
                .slider {
                  @apply transform transition-transform duration-500 ease-in-out;

                  .slide {
                    @apply flex-col flex-shrink-0 gap-10 p-6 opacity-0 rounded-[32px] transition-opacity duration-500 ease-in-out;

                    @screen md {
                      @apply p-8;
                    }

                    @screen xl {
                      @apply flex-row;
                    }

                    &.blizzard {
                      @apply bg-blizzard-100;

                      .type {
                        @apply border-blizzard-300;

                        i {
                          @apply text-blizzard-500;
                        }
                      }

                      :deep(.description) {
                        ul {
                          li {
                            &::before {
                              @apply text-blizzard-400 !important;
                            }
                          }
                        }
                      }
                    }

                    &.grey-blue {
                      @apply bg-grey-blue-100;

                      .type {
                        @apply border-grey-blue-300;

                        i {
                          @apply text-grey-blue-500;
                        }
                      }

                      :deep(.description) {
                        ul {
                          li {
                            &::before {
                              @apply text-grey-blue-600 !important;
                            }
                          }
                        }
                      }
                    }

                    &.livestorm-blue {
                      @apply bg-livestorm-blue-100;

                      .type {
                        @apply border-livestorm-blue-300;

                        i {
                          @apply text-livestorm-blue-500;
                        }
                      }

                      :deep(.description) {
                        ul {
                          li {
                            &::before {
                              @apply text-livestorm-blue-400 !important;
                            }
                          }
                        }
                      }
                    }

                    &.live-red {
                      @apply bg-live-red-100;

                      .type {
                        @apply border-live-red-300;

                        i {
                          @apply text-live-red-500;
                        }
                      }

                      :deep(.description) {
                        ul {
                          li {
                            &::before {
                              @apply text-live-red-400 !important;
                            }
                          }
                        }
                      }
                    }

                    &.sirocco {
                      @apply bg-sirocco-100;

                      .type {
                        @apply border-sirocco-300;

                        i {
                          @apply text-sirocco-500;
                        }
                      }

                      :deep(.description) {
                        ul {
                          li {
                            &::before {
                              @apply text-sirocco-400 !important;
                            }
                          }
                        }
                      }
                    }

                    &.sunburst-red {
                      @apply bg-sunburst-red-100;

                      .type {
                        @apply border-sunburst-red-300;

                        i {
                          @apply text-sunburst-red-500;
                        }
                      }

                      :deep(.description) {
                        ul {
                          li {
                            &::before {
                              @apply text-sunburst-red-400 !important;
                            }
                          }
                        }
                      }
                    }

                    &.active {
                      @apply opacity-100;
                    }

                    .illustration {
                      @apply hidden;

                      @screen xl {
                        @apply flex order-last rounded;
                      }
                    }

                    .description {
                      @apply flex-col;

                      .type {
                        @apply self-start items-center justify-center h-14 w-14 border-2 rounded-2xl;

                        i {
                          @apply text-2xl;
                        }
                      }

                      .h3 {
                        @apply mt-4 text-origin leading-7;

                        @screen mdminus {
                          @apply text-xl;
                        }

                        @screen mdplus {
                          @apply text-xl;
                        }

                        & + p {
                          @apply mt-2;
                        }
                      }

                      .button {
                        @apply self-start h-[50px] px-0;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .aside {
      @apply flex-col mt-14;

      @screen md {
        @apply mt-20;
      }

      @screen xl {
        @apply w-span3 mt-0;
      }

      > .wrapper {
        @apply mt-8;

        &:first-child {
          @apply mt-0;
        }
      }

      .built-by {
        @apply flex-col;

        .tags {
          @apply flex-wrap;

          .tag {
            @apply w-auto mt-2 mr-2 px-2 bg-grey-blue-100 font-medium text-xs text-grey-blue-700 leading-6 rounded-xs;

            &:last-child {
              @apply mr-0;
            }
          }
        }
      }

      .informations {
        @apply flex-col;

        .tags {
          @apply flex-wrap mt-0;

          .is-enterprise-only,
          .is-featured,
          .is-new {
            @apply flex self-end mr-2 mt-2;

            &:last-child {
              @apply mr-0;
            }

            picture {
              @apply mr-1 rounded-none;
            }

            :deep(p) {
              @apply font-medium text-xs;
            }
          }

          .is-enterprise-only {
            @apply bg-grey-blue-200;

            :deep(p) {
              @apply text-grey-blue-600;
            }
          }

          .is-featured {
            @apply bg-sunburst-red-200;

            :deep(p) {
              @apply text-sunburst-red-500;
            }
          }

          .is-new {
            @apply bg-winter-green-100;

            :deep(p) {
              @apply text-winter-green-600;
            }
          }
        }

        .links {
          @apply flex-col gap-4 mt-4;

          .anchor {
            @apply items-center text-base text-livestorm-blue-700;

            i {
              @apply ml-2 text-base text-livestorm-blue-700 leading-none;
            }
          }
        }
      }

      .integrated-with {
        @apply flex-col;

        .tags {
          @apply flex-wrap;

          .tag {
            @apply w-auto mt-2 mr-2 px-2 bg-grey-blue-100 font-medium text-xs text-grey-blue-700 leading-6 rounded-xs;

            &:last-child {
              @apply mr-0;
            }
          }
        }
      }

      .category {
        @apply flex-col;

        .tags {
          @apply flex-wrap;

          .tag {
            @apply w-auto mt-2 mr-2 px-2 bg-grey-blue-100 font-medium text-xs text-grey-blue-700 leading-6 rounded-xs;

            &:last-child {
              @apply mr-0;
            }
          }
        }
      }

      .shared-data {
        @apply flex-col;

        .list {
          @apply flex-col mt-2;

          .item {
            @apply py-2 border-t border-grey-blue-200;

            &:first-child {
              @apply border-none;

              p {
                @apply font-medium;
              }
            }

            p {
              @apply w-full text-sm text-grey-blue-600 leading-6 truncate;
              max-width: calc((100% - 24px) / 2);

              & + p {
                @apply ml-6;
              }
            }
          }
        }
      }

      .permissions {
        @apply flex-col;

        .content {
          @apply flex flex-col mt-2;

          :deep(p) {
            @apply text-grey-blue-600 text-sm leading-6 whitespace-pre-wrap;
          }

          :deep(ol) {
            li {
              @apply mt-1 font-normal text-grey-blue-600 text-sm leading-6 list-decimal list-inside marker:text-livestorm-blue-700;

              &:first-child {
                @apply mt-0;
              }
            }
          }

          :deep(ul) {
            li {
              @apply block mt-1 font-normal text-grey-blue-600 text-sm leading-6;

              &:first-child {
                @apply mt-0;
              }

              &::before {
                @apply inline-block w-[10px] h-[10px] bg-livestorm-blue-700 mr-2 rounded-[3px] content-[''];
              }
            }
          }

          :deep(ul + ul),
          :deep(ul + ol),
          :deep(ul + p),
          :deep(ol + ol),
          :deep(ol + ul),
          :deep(ol + p),
          :deep(p + ol),
          :deep(p + ul),
          :deep(p + p) {
            @apply mt-1;
          }
        }
      }
    }
  }

  .need-anything-else {
    @apply h-[475px] mt-14;

    @screen md {
      @apply h-auto mt-26;
    }

    .inner {
      @apply relative flex-col p-8 pb-0 bg-winter-green-100 rounded-4xl overflow-hidden;

      @screen md {
        @apply pb-6;
      }

      @screen xl {
        @apply max-w-[840px] p-12 pb-8;
      }

      .background {
        @apply absolute rounded-none z-0;

        &.desktop {
          @apply hidden;

          @screen md {
            @apply flex -right-20 top-0;
          }

          @screen xl {
            @apply -right-4;
          }
        }

        &.mobile {
          @apply bottom-0 left-0 rounded-none;

          @screen md {
            @apply hidden;
          }
        }
      }

      .h4 {
        @apply text-winter-green-700 z-10;
      }

      .h4 + p {
        @apply mt-4 text-origin text-grey-blue-600 leading-7 z-10;

        @screen md {
          @apply max-w-[354px];
        }

        @screen xl {
          @apply max-w-[424px];
        }
      }

      .button {
        @apply self-start mt-6 px-0 py-4 font-bold text-origin text-winter-green-600 leading-none z-10;

        i {
          @apply ml-2 font-bold text-winter-green-600;
        }
      }
    }
  }

  .you-may-like {
    @apply flex-col mt-20 pb-8;

    @screen md {
      @apply mt-34;
    }

    .head {
      @apply flex flex-row justify-between items-center;

      .line {
        @apply flex-grow border-t border-grey-blue-200 w-auto;
      }

      p {
        @apply font-medium text-sm text-grey-blue-700 px-5 uppercase;
      }
    }

    .body {
      @apply grid grid-cols-1 gap-6 mt-12;

      @screen md {
        @apply grid-cols-2 gap-10;
      }

      @screen xl {
        @apply grid-cols-3;
      }

      .integration {
        @apply col-span-1;
      }
    }
  }
}
</style>
